import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Announcement from "../../components/Home/Announcement";
import Jumbotron from "../../components/Home/Jumbotron";
import Shortcuts from "../../components/Home/Shortcuts";
import WeekControl from "../../components/Home/WeekControl";
import WeekSchedule from "../../components/Home/WeekSchedule";
import AlertService from "../../components/SweetAlert";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { config } from "../../config/index";
import { toWeekEndDate, toWeekStartDate } from "../../helpers/moment";
import "./styles.css";
const { API_URL } = config;

const Home = ({ client, sites }) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  const activeSite = localStorage.getItem("default_site_id")
    ? Number(localStorage.getItem("default_site_id"))
    : null;
  const token = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : null;
  const [activeWeek, setActiveWeek] = useState({
    startDate: toWeekStartDate(moment()),
    endDate: toWeekEndDate(moment()),
  });
  const [defaultSiteData, setDefaultSiteData] = React.useState(null);

  const submitRollCall = async (id, type) => {
    try {
      let response = await fetch(
        `${API_URL}/notification/associate/${user.id}/rollcall`,
        {
          method: "POST",
          body: JSON.stringify({ notification_id: id, type }),
          withCredentials: true,
          mode: "cors",
          headers: {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      );

      let responseData = await response.json();

      if (response.ok) {
        ToastUtil.success(responseData.message);
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRollCalls = async () => {
    if (activeSite) {
      try {
        const url = `${API_URL}/associate/${user.id}/site/${activeSite}/rollcalls`;

        let response = await fetch(url, {
          mode: "cors",
          method: "GET",
          withCredentials: true,
          headers: {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json; charset=utf-8",
          },
        });

        let responseData = await response.json();

        if (response.ok) {
          let rollCallsData = responseData.data;

          for (const item of rollCallsData) {
            const rollcallsResult = await AlertService.reminder(
              "",
              item.message
            );

            if (rollcallsResult.isConfirmed) {
              await submitRollCall(item.id, "Acknowledge");
            } else {
              await submitRollCall(item.id, "Ignore");
            }
          }
        } else {
          console.log(response.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getNotificationMessage = async () => {
    return `
    <p style="text-align: left;padding-top: 20px;">Dear <span style="font-weight: 500;text-decoration: underline;">${
      user.first_name
    }</span>,</p>

    <p style="text-align: left;">ADDENDUM I TO MEMORANDUM OF TERMS OF EMPLOYMENT</p>

    <p style="text-align: left;">With reference to the Memorandum of Terms of Employment between Manpower Professional Singapore Pte Ltd (“Manpower”) and <span style="font-weight: 500;text-decoration: underline;">${
      user.first_name
    }</span>, NRIC/FIN Number: <span style="font-weight: 500;text-decoration: underline;">${
      user.nric || ""
    }</span> (“Contract Staff”) executed by Contract Staff on <span style="font-weight: 500;text-decoration: underline;">${
      moment(user.schedule_a_date).isValid()
        ? moment(user.schedule_a_date).format("D MMMM YYYY")
        : ""
    }</span> (“Memorandum”), parties now agree to enter into this Addendum I.</p>

    <p style="text-align: left;">1.This Addendum I to Memorandum shall be effective on the date of its execution by Contract Staff.</p>

    <p style="text-align: left;">2.Memorandum is amended as follows:</p>

    <p style="text-align: left;">a.“Mobile Phone Reimbursement” shall be amended and replaced with the following:</p>

    <p style="text-align: left;">“Mobile Phone Allowance:You are entitled to mobile phone allowance of S$50.00 per month. The mobile phone allowance will be pro-rated for any incomplete month of service and is calculated in direct proportion to the total number of working days in that month.”</p>

    <p style="text-align: left;">3.The following provisions apply to and comprise Memorandum: (a)The contents of this Addendum I; and (b)Memorandum of Terms of Employment executed by Contract Staff on <span style="font-weight: 500;text-decoration: underline;">${
      moment(user.schedule_a_date).isValid()
        ? moment(user.schedule_a_date).format("D MMMM YYYY")
        : ""
    }
    </span>. In the event of any conflict between or among these documents, the above order of precedence shall apply, but only where a document explicitly deviates from or adds to a lower ranked document. No other terms or conditions of Memorandum shall be negated or changed as a result of this Addendum I.</p>

    <p style="text-align: left;">4.This Addendum I shall be governed by and construed in accordance with the laws of Singapore.</p>

    </br><p style="text-align: left;">Yours sincerely,
    </br>Doreen Goh Soh Huang (R1114537)
    </br>Senior HR Manager</p>`;
  };

  const fetchScheduledNotification = async () => {
    try {
      const url = `${API_URL}/associate/${user.id}/schedule-notification`;

      let response = await fetch(url, {
        mode: "cors",
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json; charset=utf-8",
        },
      });

      let responseData = await response.json();

      if (response.ok) {
        let data = responseData.data;
        let message = await getNotificationMessage();
        if (data.notify_associate) {
          const rollcallsResult = await AlertService.scheduleReminder(
            "",
            message
          );

          if (rollcallsResult.isConfirmed) {
            await submitAcknowledge("Acknowledge", message);
          }
        }
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const submitAcknowledge = async (status, message) => {
    try {
      let response = await fetch(
        `${API_URL}/associate/${user.id}/schedule-acknowledge`,
        {
          method: "POST",
          body: JSON.stringify({ status, message }),
          withCredentials: true,
          mode: "cors",
          headers: {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      );

      let responseData = await response.json();

      if (response.ok) {
        ToastUtil.success(responseData.message);
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    sites && defaultSiteHandler();
  }, [sites]);

  React.useEffect(() => {
    fetchScheduledNotification();
  }, []);

  useEffect(() => {
    client &&
      setActiveWeek({
        startDate: toWeekStartDate(moment(), client.start_day),
        endDate: toWeekEndDate(moment(), client.start_day),
      });
  }, [client]);

  useEffect(() => {
    fetchRollCalls();
  }, [activeSite]);

  const defaultSiteHandler = () =>
    setDefaultSiteData(sites.find((site) => site.id === activeSite));

  const nextWeekHandler = () =>
    setActiveWeek({
      startDate: activeWeek.startDate.add(1, "week"),
      endDate: activeWeek.endDate.add(1, "week"),
    });

  const prevWeekHandler = () =>
    setActiveWeek({
      startDate: activeWeek.startDate.subtract(1, "week"),
      endDate: activeWeek.endDate.subtract(1, "week"),
    });

  return (
    <React.Fragment>
      <div className="rounded-0 mb-0 dashboard__jumbotron-container home-container">
        <div className="home-wrapper">
          <Jumbotron client={client} />
        </div>
        <div
          style={{
            margin: 25,
            alignContent: "center",
          }}
        >
          <h5>{defaultSiteData?.name || ""}</h5>
          {sites.length > 1 && (
            <p>
              <a href="/site-settings">Change</a>
            </p>
          )}
        </div>
      </div>
      <Announcement t={t} />
      <Shortcuts client={client} defaultSiteData={defaultSiteData} t={t} />
      {client && client.enable_smart_scheduler === true && activeSite && (
        <React.Fragment>
          <WeekControl
            setTitle={true}
            client={client}
            activeWeek={activeWeek}
            nextWeek={nextWeekHandler}
            prevWeek={prevWeekHandler}
            t={t}
          />
          <WeekSchedule
            client={client}
            sites={sites}
            flag="home"
            activeWeek={activeWeek}
            activeSite={activeSite}
            t={t}
          />
          <br />
          <br />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Home;
